
import PageState from "./state"
import mutations from "./mutations"
import {getModule} from '@/store/store'
let APIS = {
  getSpeakerEmotionList: `get /apis/baohuo-yuanchuang/v1/speaker/getSpeakerEmotionList`,
  getStoreSearchCriteria: `get /apis/baohuo-yuanchuang/v1/storeSpeakerV2/getStoreSearchCriteria`, // 发音人分类
  // getUserSpeakerByType: 'get /apis/baohuo-yuanchuang/v1/mediaPlayer/getUserSpeakerByType', // 获取用户相关发音人类型[已购/常用/我的/收藏] 或者该接口不调用,直接查询sort =3
  // getSpeakerBySearch:`get /apis/baohuo-yuanchuang/v4/speaker/search`,//根据关键字查找发音人
  queryMemberLeftRight:'get /apis/baohuo-account/v1/memberCenter/queryMemberLeftRight',
  getSpeakerBySearch:`get /apis/baohuo-yuanchuang/speaker/store/search`,//新
  collectSave:`post /apis/baohuo-yuanchuang/speaker/collect/save`//收藏声音
}
export default {
  ...getModule({
    state:new PageState(),
    mutations,
    actions:{},
    APIS,
    name:"searchSpeakerPage"
  })
}